import { useState, useEffect } from "react";
import Pagination from "../shared/pagination";
import Loader from "../shared/loader";
import arrayUtilities from "../../utilities/arrayUtilities";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import api from "../api/api";
import stringHelpers from "../../utilities/stringHelpers";
import { toDateTimeString } from "../../utilities/dateUtilities";
import {Modal, Button} from 'react-bootstrap'
import { SearchBarWithDebounce } from "../shared/searchBarWithDebounce";
import { FiltersModalTrigger } from "../shared/filtersModalTrigger";
import { AppliedFilterDisplay } from "../shared/appliedFilterDisplay";
import { AuditLogFiltersModal } from "./filters-modals/AuditLogFiltersModal";

export default function AuditLog({users, sites, organisationId, token}) {
    const [auditLogData, setAuditLogData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [pageNumber, setPageNumber] = useState(0);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [selectedUser, setSelectedUser] = useState(null)
    const [entities, setEntities] = useState(null)
    const [entity, setEntity] = useState(null)
    const [actions, setActions] = useState(null)
    const [action, setAction] = useState("")
    const [modalLog, setModalLog] = useState(null)
    const [showFiltersModal, setShowFiltersModal] = useState(false);
    const [showFilterPills, setShowFilterPills] = useState(false);
    const [appliedFilters, setAppliedFilters] = useState(null);

    const fetchAuditLogData = (page, searchQuery, from, to, user, entityValue, actionValue) => {
        setIsLoading(true)
        api.searchAuditLog(
            data => {
                setAuditLogData(data)
                setIsLoading(false)
            },
            error => {
                setAuditLogData(null)
                setIsLoading(false)
                console.log(error)
            },
            page, 100,
            searchQuery,
            !stringHelpers.isNullOrEmpty(user) ? user : null,
            from, to,
            !stringHelpers.isNullOrEmpty(entityValue) ? entityValue : null,
            !stringHelpers.isNullOrEmpty(actionValue) ? actionValue : null,
            organisationId, token
        )
    }

    useEffect(() => {
        fetchAuditLogData(0, searchQuery, fromDate, toDate, selectedUser, entity, action);
        api.getAuditLogEntities(
            data => setEntities(data),
            error => {
                setEntities(null)
                console.log(error)
            },
            organisationId, token
        )
        api.getAuditLogActions(
            data => setActions(data),
            error => {
                setActions(null)
                console.log(error)
            },
            organisationId, token
        )
    }, []);

    useEffect(() => {
        fetchAuditLogData(pageNumber, searchQuery, fromDate, toDate, selectedUser, entity, action);
    }, [pageNumber]);

    const changepageNumber = (num) => {
        setPageNumber(num);
    };

    const clearFilters = () => {
        setPageNumber(0);
        setFromDate(null)
        setToDate(null)
        setEntity(null)
        setAction("")
        setSelectedUser(null)
        setAppliedFilters(null)
        setShowFilterPills(false)
        fetchAuditLogData(0, searchQuery, null, null, null, null, "");
    }

    const clearFilterByLabel = (label) => {
        switch (label) {
            case "From":
                setFromDate(null)
                fetchAuditLogData(0, searchQuery, null, toDate, selectedUser, entity, action)
                break
            case "To":
                setToDate(null)
                fetchAuditLogData(0, searchQuery, fromDate, null, selectedUser, entity, action)
                break
            case "Date Range":
                setFromDate(null)
                setToDate(null)
                fetchAuditLogData(0, searchQuery, null, null, selectedUser, entity, action)
                break
            case "User":
                setSelectedUser(null)
                fetchAuditLogData(0, searchQuery, fromDate, toDate, null, entity, action)
                break
            case "Entity":
                setEntity(null)
                fetchAuditLogData(0, searchQuery, fromDate, toDate, selectedUser, null, action)
                break
            case "Action":
                setAction("")
                fetchAuditLogData(0, searchQuery, fromDate, toDate, selectedUser, entity, "")
                break
            default:
                break
        }
        setPageNumber(0)
    }

    const findSiteObject = (siteId) => {
        const site = sites.find(item => item.id === siteId)
        if (site !== undefined) {
            return site
        }
    }

    const renderEntity = (log) => {
        const baseUrl = `/organisation/${organisationId}`

        const linkableEntities = {
            Site: `/client/${findSiteObject(log.entityId)?.clientId}/site/${log.entityId}`,

            LetterTemplateContravention: `/contravention/${log.entityId}`,

            LetterTemplate: `/document-template/${log.entityId}`,

            Client: `/client/${log.entityId}`,

            Organisation: "",

            Tag: `/tag-settings/tag/${log.entityId}`,

            CancellationReason: `/cancellation-reason/${log.entityId}`,

            Contravention: `/contravention/${log.entityId}`,

            Suspension: `/enforcement-suspension/${log.entityId}`,

            ReferenceNumberRange: `/reference-number-range/${log.entityId}`,

            Region: `/regions`,

            Settings: `/organisation-settings`
        }

        if (!stringHelpers.isNullOrEmpty(log.entityId) && linkableEntities.hasOwnProperty(log.entity)) {
            return <Link to={`${baseUrl}${linkableEntities[log.entity]}`}>
                <h6 className="m-0">
                    {stringHelpers.upperCamelCaseToStartCase(log.entity)}
                </h6>
            </Link>
        } else {
            return <>{stringHelpers.upperCamelCaseToStartCase(log.entity)}</>
        }
    }

    return <div className="container-fluid audit-log-data">
            <div className="row">
                <div className="col-12">
                    <div className="card mb-3">
                        <div className="card-header d-flex align-items-center justify-content-between">
                            <h5 className="d-flex align-items-center">Audit Log</h5>
                            <div className="d-flex justify-content-between align-items-center">
                                <div className="d-flex align-items-center">
                                    <div className='mr-2'>
                                        <SearchBarWithDebounce
                                            onSearchQueryChange={ query => {
                                                setSearchQuery(query)
                                                setPageNumber(0)
                                                fetchAuditLogData(0, query, fromDate, toDate, selectedUser, entity, action)
                                            } }
                                        />
                                    </div>
                                    <div className='mr-2'>
                                        <FiltersModalTrigger onClick={ () => setShowFiltersModal(true) } />
                                    </div>
                                </div>
                                <div className="d-flex align-items-start">
                                    <button
                                        className="btn btn-primary btn-sm mr-1 ml-1 nowrap"
                                        onClick={ () => fetchAuditLogData(pageNumber, searchQuery, fromDate, toDate, selectedUser, entity, action) }>
                                        <i className="fas fa-redo mr-1"></i>Refresh
                                    </button>
                                </div>
                            </div>
                        </div>
                        {
                            showFilterPills && appliedFilters &&
                            <div className="px-3 py-2 border-top d-flex align-items-center flex-wrap">
                                {
                                    Object.entries(appliedFilters).map(
                                        ([label, value]) => !stringHelpers.isNullOrEmpty(value)
                                        && <div className="mr-2" key={label}>
                                            <AppliedFilterDisplay
                                                label={label}
                                                onTextClick={() => setShowFiltersModal(true)}
                                                onCloseClick={closedLabel => {
                                                    clearFilterByLabel(closedLabel)
                                                    setAppliedFilters(prevState => {
                                                        const updatedFilters = { ...prevState }
                                                        if (closedLabel === "From" || closedLabel === "To" || closedLabel === "Date Range") {
                                                            updatedFilters.From = null
                                                            updatedFilters.To = null
                                                            updatedFilters["Date Range"] = null
                                                        } else {
                                                            updatedFilters[closedLabel] = null
                                                        }
                                                        const hasRemainingFilters = Object.values(updatedFilters).some(value => !stringHelpers.isNullOrEmpty(value))
                                                        return hasRemainingFilters ? updatedFilters : null
                                                    })
                                                }}
                                                value={value}
                                            />
                                        </div>
                                    )
                                }
                                {appliedFilters && Object.keys(appliedFilters).length > 0 && <button type="button" className="btn btn-none p-0 m-0 fs--1 nowrap" onClick={() => clearFilters()}>Clear all filters</button>}
                            </div>
                        }
                        { isLoading
                            ? <Loader />
                            : <div className="card-body bg-white border-top details-container p-0 overflow-auto">
                                <table className="table table-sm mb-0 table-striped table-dashboard fs--1 data-table border-bottom border-200 no-footer ">
                                    <thead className="bg-200 text-900">
                                        <tr>
                                            <th>Timestamp</th>
                                            <th>User</th>
                                            <th>Organisation</th>
                                            <th>Entity</th>
                                            <th>Action</th>
                                            <th>Note</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {
                                            !arrayUtilities.isNullOrEmpty(auditLogData?.items) &&
                                            auditLogData.items.map(item =>
                                                <tr key={ item.id }>
                                                    <td>{toDateTimeString(item.timestamp)}</td>
                                                    <td>{item.userName}</td>
                                                    <td>{item.organisationName}</td>
                                                    <td>{renderEntity(item)}</td>
                                                    <td>{item.action}</td>
                                                    <td className="note-cell">
                                                        <div className="d-flex align-items-center justify-content-between overflow-hidden">
                                                            <p className="text-ellipsis m-0">{item.note}</p>
                                                            <button onClick={() => setModalLog(item)} className="btn btn-none p-0 m-0" type="button">
                                                                <i className="fas fa-eye"></i>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>)
                                        }
                                    </tbody>
                                </table>
                            </div>
                        }
                    </div>


                    <div className="d-flex justify-content-center row align-items-center pt-2">
                        <div className="col-auto align-items-center">
                            <Pagination totalResults={ auditLogData?.totalCount } currentPage={ pageNumber } changePageNumber={ changepageNumber } />
                        </div>
                    </div>
                </div>
            </div>
            {
                modalLog &&
                <Modal size='lg' show onHide={ () => setModalLog(null) } centered>
                    <Modal.Header>
                        <Modal.Title>Audit Log</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div>
                            <div className="row mb-3">
                                <div className="col-4">
                                    <p className="font-weight-semi-bold m-0">Timestamp</p>
                                </div>
                                <div className="col-8">
                                    <p className="m-0">{toDateTimeString(modalLog.timestamp)}</p>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-4">
                                    <p className="font-weight-semi-bold m-0">User</p>
                                </div>
                                <div className="col-8">
                                    <p className="m-0">{modalLog.userName}</p>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-4">
                                    <p className="font-weight-semi-bold m-0">Organisation</p>
                                </div>
                                <div className="col-8">
                                    <p className="m-0">{modalLog.organisationName}</p>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-4">
                                    <p className="font-weight-semi-bold m-0">Entity</p>
                                </div>
                                <div className="col-8">
                                    <p className="m-0">{modalLog.entity}</p>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-4">
                                    <p className="font-weight-semi-bold m-0">Action</p>
                                </div>
                                <div className="col-8">
                                    <p className="m-0">{modalLog.action}</p>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-4">
                                    <p className="font-weight-semi-bold m-0">Note</p>
                                </div>
                                <div className="col-8">
                                    <p className="m-0" style={{wordBreak: "break-word"}}>{modalLog.note}</p>
                                </div>
                            </div>
                        </div>
                        {/*  */}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button size="sm" variant='secondary' onClick={ () => setModalLog(false) }>Close</Button>
                    </Modal.Footer>
                </Modal>
            }
            {
                showFiltersModal &&
                <AuditLogFiltersModal
                    showModal={ showFiltersModal }
                    handleClose={ () => setShowFiltersModal(false) }
                    handleConfirm={ (draftFilters) => {
                        setFromDate(draftFilters.fromDate)
                        setToDate(draftFilters.toDate)
                        setSelectedUser(draftFilters.selectedUser)
                        setEntity(draftFilters.entity)
                        setAction(draftFilters.action)
                        setAppliedFilters(draftFilters.appliedFilters)
                        setShowFilterPills(true)
                        setShowFiltersModal(false)
                        setPageNumber(0)
                        fetchAuditLogData(0, searchQuery, draftFilters.fromDate, draftFilters.toDate, draftFilters.selectedUser, draftFilters.entity, draftFilters.action)
                    } }
                    initialFromDate={ fromDate }
                    initialToDate={ toDate }
                    initialSelectedUser={ selectedUser }
                    initialEntity={ entity }
                    initialAction={ action }
                    initialAppliedFilters={ appliedFilters }
                    users={ users }
                    entities={ entities }
                    actions={ actions }
                    key="audit-log-filters-modal"
                />
            }
        </div>
}
